import { SuccessModal } from '@components/core/success-modal.component.tsx';
import { Avatar, AvatarFallback, AvatarImage } from '@components/ui/avatar.tsx';
import { displayLocation } from '@utils/functions.util';
import { BuildingIcon } from 'lucide-react';
import { FunctionComponent, useState } from 'react';

type SuccessStepProps = {
  city: string;
  companyName: string;
  country?: string;
  logoUrl?: string;
  onContinue: (submit?: boolean) => void;
  state?: string;
};

export const SuccessStep: FunctionComponent<SuccessStepProps> = ({
  city,
  companyName,
  country,
  logoUrl,
  state,
  onContinue,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(true);

  const handleClose = () => {
    setIsModalOpen(false);
  };

  const handleContinue = () => {
    setIsModalOpen(false);
    onContinue(true);
  };

  const information = (
    <div className="flex flex-row items-center gap-2 rounded-md bg-gray-100 px-2 py-2 w-[60%]">
      <Avatar className="h-9 w-9 m-2">
        <AvatarImage src={logoUrl} />
        <AvatarFallback>
          <BuildingIcon />
        </AvatarFallback>
      </Avatar>
      <div className="flex flex-col items-start gap-1">
        <div className="text-xs">{companyName}</div>
        <div className="text-left font-light text-gray-600 text-xs">
          {displayLocation({
            city,
            countryCode: country,
            state,
          })}
        </div>
      </div>
    </div>
  );

  return (
    <SuccessModal
      continueMessage="Add Technology"
      isOpen={isModalOpen}
      onClose={handleClose}
      onContinue={handleContinue}
      title="Organization Added"
      text="Your organization profile has been created."
      information={information}
      nextStep="Next, let's add your first Technology, on your way to getting your first TRL Score"
      width="500px"
    />
  );
};
